import {useRef, useEffect, useState} from "@wordpress/element";

const settings = window?.wc?.wcSettings?.getSetting( 'acceptblue-google-pay_data', {} );
const label = window?.wp?.htmlEntities?.decodeEntities( settings.title ) || window?.wp?.i18n.__( 'Accept.blue Google Pay', 'acceptblue-google-pay' );

const GooglePayButton = (props) => {
    let [googlePayToken, setGooglePayToken] = useState(null);
    let [hasErrors, setHasErrors] = useState(false);
    let googleButtonRef = useRef(null);
    const [footerComponents, setFooterComponents] = useState([]);
    const [headerComponents, setHeaderComponents] = useState([]);

    const { eventRegistration, emitResponse } = props;
    const { onPaymentSetup } = eventRegistration;


    function test() {
        useEffect(() => {
            const unsubscribe = onPaymentSetup(async function () {
                const ab_token = googlePayToken;
                if (!hasErrors) {
                    return {
                        type: emitResponse.responseTypes.SUCCESS,
                        meta: {
                            paymentMethodData: {
                                ab_token
                            },
                        },
                    };
                }

                return {
                    type: emitResponse.responseTypes.ERROR,
                    message: globalError,
                };
            });

            return () => unsubscribe();
        }, [
            emitResponse.responseTypes.ERROR,
            emitResponse.responseTypes.SUCCESS,
            onPaymentSetup,
            googlePayToken,
        ]);
    }


    const baseRequest = {
        apiVersion: 2,
        apiVersionMinor: 0
    };

    const allowedCardNetworks = ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"];

    const allowedCardAuthMethods = ["PAN_ONLY"];

    const tokenizationSpecification = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
            'gateway': 'acceptblue',
            'gatewayMerchantId': settings.merchant_id
        }
    };

    const baseCardPaymentMethod = {
        type: 'CARD',
        parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks
        }
    };

    const cardPaymentMethod = Object.assign(
        {},
        baseCardPaymentMethod,
        {
            tokenizationSpecification: tokenizationSpecification
        }
    );

    let paymentsClient = null;

    function getGoogleIsReadyToPayRequest() {
        return Object.assign(
            {},
            baseRequest,
            {
                allowedPaymentMethods: [baseCardPaymentMethod]
            }
        );
    }

    function getGooglePaymentDataRequest() {
        const paymentDataRequest = Object.assign({}, baseRequest);
        paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
        paymentDataRequest.transactionInfo = {
            ...settings.transaction_info,
            totalPrice: (parseFloat(settings.transaction_info['totalPrice']) + parseFloat(settings.surcharge_amount)).toFixed(2).toString()
        };
        paymentDataRequest.merchantInfo = {
            merchantId: settings.merchant_id,
            merchantName: settings.merchant_name,
        };

        paymentDataRequest.callbackIntents = ["PAYMENT_AUTHORIZATION"];

        return paymentDataRequest;
    }

    function getGooglePaymentsClient() {
        if ( paymentsClient === null ) {
            paymentsClient = new google.payments.api.PaymentsClient({
                environment: settings.mode,
                paymentDataCallbacks: {
                    onPaymentAuthorized: onPaymentAuthorized
                }
            });
        }
        return paymentsClient;
    }

    useEffect(() => {
        (function () {
            const paymentsClient = getGooglePaymentsClient();
            paymentsClient.isReadyToPay(getGoogleIsReadyToPayRequest())
                .then(function(response) {
                    if (response.result) {
                        addGooglePayButton();
                        prefetchGooglePaymentData();
                    }
                })
                .catch(function(err) {
                    console.log(err);
                });
        })();

        return () => false;
    }, []);

    function prefetchGooglePaymentData() {
        const paymentDataRequest = getGooglePaymentDataRequest();
        // transactionInfo must be set but does not affect cache
        paymentDataRequest.transactionInfo = {
            totalPriceStatus: 'NOT_CURRENTLY_KNOWN',
            currencyCode: 'USD'
        };
        const paymentsClient = getGooglePaymentsClient();
        paymentsClient.prefetchPaymentData(paymentDataRequest);
    }

    function addGooglePayButton() {
        const paymentsClient = getGooglePaymentsClient();
        const button = paymentsClient.createButton({
            onClick: onGooglePaymentButtonClicked,
            allowedPaymentMethods: [baseCardPaymentMethod]
        });

        googleButtonRef.current.innerHTML = '';
        googleButtonRef.current.appendChild(button);
    }

    function onGooglePaymentButtonClicked() {
        const paymentDataRequest = getGooglePaymentDataRequest();
        paymentDataRequest.transactionInfo = {
            ...settings.transaction_info,
            totalPrice: (parseFloat(settings.transaction_info['totalPrice']) + parseFloat(settings.surcharge_amount)).toFixed(2).toString()
        };

        console.log(paymentDataRequest.transactionInfo);
        const paymentsClient = getGooglePaymentsClient();
        paymentsClient.loadPaymentData(paymentDataRequest);
    }

    function onPaymentAuthorized(paymentData) {
        return new Promise(function(resolve, reject){
            processPayment(paymentData)
                .then(function() {
                    resolve({transactionState: 'SUCCESS'});
                })
                .catch(function() {
                    resolve({
                        transactionState: 'ERROR',
                        error: {
                            intent: 'PAYMENT_AUTHORIZATION',
                            message: 'Insufficient funds',
                            reason: 'PAYMENT_DATA_INVALID'
                        }
                    });
                });
        });
    }

    function processPayment(paymentData) {
        return new Promise(async function(resolve, reject) {
            const paymentToken = paymentData.paymentMethodData.tokenizationData.token;
            console.log(paymentData);
            setGooglePayToken(paymentToken);
            const checkoutButton = document.querySelector('form.wc-block-components-form.wc-block-checkout__form button.wc-block-components-checkout-place-order-button');            if(checkoutButton) {
                checkoutButton.click();
                test();
                resolve();
            }else{
                reject();
                alert('Error! Something went wrong!');
            }

        });
    }

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('pgabfw-renderFooterComponentsGooglePay', {
            detail: {
                setComponent: component => setFooterComponents([ ...footerComponents, component ])
            }
        }));
        window.dispatchEvent(new CustomEvent('pgabfw-renderHeaderComponentsGooglePay', {
            detail: {
                setComponent: component => setHeaderComponents([ ...headerComponents, component ])
            }
        }));
    }, []);

    return (
        <>
            {headerComponents.map( component => component )}
            <div className="acceptblue-google-pay" ref={googleButtonRef} >
            </div>
            {footerComponents.map( component => component )}
        </>
    );
}

const AcceptBlueGooglePay = {
    name: 'acceptblue-google-pay',
    label: label,
    content: <GooglePayButton/>,
    edit: <GooglePayButton/>,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports,
    },
};

window.wc.wcBlocksRegistry.registerPaymentMethod(AcceptBlueGooglePay);